// extracted by mini-css-extract-plugin
module.exports = {"menuItem":"ProfileMenuItem__menuItem___2MSxu","locationIcon":"ProfileMenuItem__locationIcon____8n3Z","tpb":"ProfileMenuItem__tpb___3E8hW"};